<mat-tab-group>
  <mat-tab label="{{pageTitle}}">
    <div class="">
      <p-table
        styleClass="risk-table-striped"
        [value]="evidenceCentralItems"
        *ngIf="evidenceCentralItems"
        dataKey="id"
        #evidenceCentralItemsTbl
        [tableStyle]="{ 'width': '100%' }"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem"></th>
            <th class="font-bold white-space-nowrap">Name</th>
            <th class="font-bold white-space-nowrap">Type</th>
            <th class="font-bold white-space-nowrap">Status</th>
            <th class="font-bold white-space-nowrap">Created</th>
            <th class="font-bold white-space-nowrap">Last Run</th>
            <th style="width: 3rem; text-align: right;">
              <p-button icon="pi pi-plus"
                        [outlined]="true"
                        severity="secondary"
                        class="ml-auto"
                        (click)="editEvidenceCentralItem()"
                        pTooltip="Create New"></p-button>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-expanded="expanded">
          <tr>
            <td>
              <button
                type="button"
                pButton
                pRipple
                [pRowToggler]="item"
                class="p-button-text p-button-rounded p-button-plain"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
              ></button>
            </td>
            <td>{{ item.name }}</td>
            <td>{{ item.type }}</td>
            <td>{{ item.status }}</td>
            <td>{{ item.createdDate | date : 'short' }}</td>
            <td>{{ item.updatedDate | date : 'short' }}</td>
            <td>
              <div class="flex align-items-center justify-content-center gap-1">
                <p-button *ngIf="item.integrationId"
                          [text]="true"
                          icon="pi pi-play"
                          (click)="test(item)"
                          pTooltip="Test"
                ></p-button>
                <p-button
                  [text]="true"
                  icon="pi pi-pencil"
                  (click)="editEvidenceCentralItem(item)"
                  pTooltip="Edit"
                ></p-button>
                <p-button
                  [text]="true"
                  icon="pi pi-trash"
                  severity="danger"
                  (click)="deleteEvidenceCentralItem(item)"
                  pTooltip="Delete"
                ></p-button>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="expandedrow" let-item>
          <tr>
            <td colspan="7">
              <p-table
                styleClass="risk-table-striped"
                [value]="item.logs"
                #table
                [tableStyle]="{ 'width': '100%' }"
              >
                <ng-template pTemplate="header">
                  <tr class="font-bold white-space-nowrap">
                    <th class="font-bold white-space-nowrap">Date</th>
                    <th class="font-bold white-space-nowrap">Status</th>
                    <th class="font-bold white-space-nowrap">Integration</th>
                    <th class="font-bold white-space-nowrap" style="width: 70%;">Validation</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-log>
                  <tr>
                    <td style="white-space: nowrap;">{{ log.date | date : 'short' }}</td>
                    <td>{{ log.status }}</td>
                    <td>{{ log.submitter }}</td>
                    <td>
                      <ng-container *ngIf="!log.inspectionResults.length">
                        N/A
                      </ng-container>
                      <ng-container *ngIf="log.inspectionResults && log.inspectionResults.length">
                        <ng-container *ngIf="log.filteredInspectionResults.length === 0">
                          No Findings
                        </ng-container>
                        <div *ngIf="log.filteredInspectionResults.length > 0"
                             style="cursor: pointer;text-decoration: underline;"
                             (click)="log.showDetails = !log.showDetails">
                          Findings
                        </div>
                        <ng-container *ngIf="log.showDetails">
                          <div *ngFor="let result of log.filteredInspectionResults">
                            {{format(result.condition.operator, result.condition.path, result.condition.value, result.result)}}
                          </div>
                        </ng-container>
                      </ng-container>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </mat-tab>
  <mat-tab label="Validation">
    <app-inspection-profiles></app-inspection-profiles>
  </mat-tab>
</mat-tab-group>
